import { TypedDocumentNode, gql } from '@apollo/client';
import { useCallback } from 'react';

import { useSendUserEngagementIncrement } from 'hooks/useSendUserEngagementIncrement';

import { useClaimReferralReward_referralReward } from './__generated__/useClaimReferralReward.graphql';
import { useCoreClaimReferralReward } from './useCoreClaimReferralReward';

export const useClaimReferralReward = () => {
  const { sendUserEngagementIncrement } = useSendUserEngagementIncrement();

  const claimCore = useCoreClaimReferralReward();

  return useCallback(
    (referralReward: useClaimReferralReward_referralReward) => {
      claimCore(referralReward.id);
      sendUserEngagementIncrement(80);
    },
    [claimCore, sendUserEngagementIncrement]
  );
};

useClaimReferralReward.fragments = {
  referralReward: gql`
    fragment useClaimReferralReward_referralReward on ReferralReward {
      id
      conversionCredit {
        id
      }
      card: anyCard {
        slug
        sport
      }
    }
  ` as TypedDocumentNode<useClaimReferralReward_referralReward>,
};
